import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compõe classes do Tailwind resolvendo conflitos.
 *
 * `clsx` resolve condicionais e arrays; `twMerge` desempata utilitários do
 * mesmo eixo, mantendo o último. Sem ele, `cn('p-2', 'p-4')` deixaria as duas
 * classes no DOM e o vencedor passaria a depender da ordem no CSS gerado —
 * ou seja, o override por prop deixaria de funcionar de forma previsível.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
